import {Injector} from '@angular/core';

export class InjectionManager {

  static injector: Injector;

}
